exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a {\n    cursor: pointer;\n}\n\n.btn-edcast-positive {\n  background-color: #38b6a0 !important;\n  color: #fff;\n}\n.btn-edcast-neutral {\n  background-color: #ffffff !important;\n  color:#26273b;\n  border-color: #acadc1;\n}\n\n.btn-edcast-neutral:hover {\n  background-color: #f0f0f5 !important;\n  color:#26273b;\n  border-color: #acadc1;\n}\n\n.btn-edcast-positive:hover {\n  background-color: #2F9987 !important;\n  color: #fff;\n}\n\n.btn-edcast-positive:active {\n  background-color: #2B6C60 !important;\n  color: #fff;\n}\n\n.btn-edcast-positive:focus {\n  background-color: #288070 !important;\n  color: #fff;\n  outline:0;\n}\n\n.boarded {\n  border: 1px solid #cfd0dd;\n  border-radius: 4px;\n  padding: 4px 8px;\n  cursor: default;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/material-details/material-details.component.css
// module id = 822
// module chunks = 0